module.exports = __webpack_public_path__ + "static/media/jakarta-barat.55585513.svg";